import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export { ITedMessage } from '@g99-product-web-ui/shared-interface-lib';

interface ITedAskResponse {
  answer: string;
}

@Injectable({
  providedIn: 'root',
})
export class TedService {
  private readonly _askUrl = API_ENDPOINTS.TED.ask;

  public get isReady(): boolean {
    return true;
  }

  constructor(private readonly _http: HttpClient) {}

  public loadConfig(): Observable<void> {
    return of(void 0);
  }

  public ask(question: string, businessId: string): Observable<string> {
    return this._http
      .post<ITedAskResponse>(
        this._askUrl,
        { question, businessId },
        { withCredentials: true }
      )
      .pipe(
        map((res) => res.answer?.trim() ?? 'No response from Ted.'),
        catchError(() =>
          of('Sorry, Ted is unavailable right now. Please try again.')
        )
      );
  }
}
